import services from './services';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';

export default {
    mixins: [services],
    data() {
        return {
            loading: false,
            dialogVisible: false,
            title: '',
            form: this.getFormData(),
            queryType: [{
                name: '爸爸'
            }, {
                name: '妈妈'
            }, {
                name: '爷爷'
            }, {
                name: '奶奶'
            }, {
                name: '外公'
            }, {
                name: '外婆'
            }, {
                name: '其他'
            }]
        }
    },
    methods: {
        getFormData() {
            return cloneDeep({
                "BabyId": 0,
                "ParentName": "",
                "ParentNick": "",
                "PhoneNo": ""
            })
        },
        show(options) {
            this.form = this.getFormData()
            this.dialogVisible = true
            this.title = options.title
            this.form.BabyId = options.BabyId
        },
        // 确定
        submit() {
            let checkRules = [{
                name: "家长名字",
                value: this.form.ParentName,
                required: true,
            }, {
                name: "称呼",
                value: this.form.ParentNick,
                required: true,
            }, {
                name: "家长电话",
                value: this.form.PhoneNo,
                phone: true,
            }];

            var flag = util.checkForm({
                ele: this,
                rules: checkRules
            });
            if (!flag) {
                return
            }
            this.BabyParent_Add()
        }


    },
    computed: {

    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/LBHomeOrder/components/addParent/vm.js